import React, { FC, memo } from 'react';

import { useAccountRepositoryInjector } from 'application/providers/DIContainerProvider';
import CustomInfo from 'application/pages/StreamPage/renderer/CustomInfo/CustomInfo';
import { HELP_CENTER_CONTRACTS_LINK, TARIFFS } from 'application/pages/constants';
import { TEXTS } from 'application/pages/texts';
import CompanyUtils from 'application/utils/CompanyUtils';
import { useAccountContext } from 'application/providers/AccountProvider';

import styles from './index.module.scss';

interface PopularTariffWarningProps {
  isStreamPage: boolean;
}

const PopularTariffWarning: FC<PopularTariffWarningProps> = ({ isStreamPage }) => {
  const { userOnboardingFeatures, userOnboardingFeaturesLoading } = useAccountRepositoryInjector();
  const { currentCompany } = useAccountContext();

  const isPopularTariff = CompanyUtils.compareTariff(currentCompany?.pricePlan?.alias ?? '', TARIFFS.POPULAR);

  const isCustomInfoShouldShow = !userOnboardingFeatures?.[0]?.isOnboarded && isPopularTariff && isStreamPage;

  if (isCustomInfoShouldShow && userOnboardingFeaturesLoading) {
    return <div className={styles.skeleton} />;
  }

  if (isCustomInfoShouldShow && !userOnboardingFeaturesLoading) {
    return (
      <CustomInfo
        textObject={TEXTS.MODAL_INFO}
        link={HELP_CENTER_CONTRACTS_LINK}
      />
    );
  }

  return null;
};

export default memo(PopularTariffWarning);
